import { Card, Heading } from '@dittolive/anvil'
import { graphql } from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { useAppManagementContext } from 'scenes/appManagement/context'

import { AppVisibilitySectionQuery } from './__generated__/AppVisibilitySectionQuery.graphql'
import AppVisibilityForm from './AppVisibilityForm'

const query = graphql`
  query AppVisibilitySectionQuery($appId: ID!) {
    viewer {
      appById(id: $appId) {
        visibility
      }
    }
  }
`

export default function AppVisibilitySection() {
  const { appId } = useAppManagementContext()
  const { databaseText } = useAppToDatabaseRename()
  const { viewer } = useLazyLoadQuery<AppVisibilitySectionQuery>(query, {
    appId,
  })

  return (
    <Card>
      <Card.Header>
        <Heading level={3}>Change {databaseText} visibility</Heading>
        <p className="text-foreground-subtle text-base">
          Change which role(s) in the org can see your {databaseText}
        </p>
      </Card.Header>

      <Card.Body>
        <AppVisibilityForm
          appId={appId}
          appVisibility={viewer.appById?.visibility || 'EVERYONE'}
        />
      </Card.Body>
    </Card>
  )
}
